export default "\n<ng-progress\n\n[color]=\"'#5c2799'\"\n[ease]=\"'linear'\"\n></ng-progress>\n<router-outlet></router-outlet>\n"